import { render, staticRenderFns } from "./Shifts1.container.vue?vue&type=template&id=7284fb59&scoped=true&"
import script from "./Shifts1.container.vue?vue&type=script&lang=js&"
export * from "./Shifts1.container.vue?vue&type=script&lang=js&"
import style0 from "./Shifts1.container.vue?vue&type=style&index=0&id=7284fb59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7284fb59",
  null
  
)

export default component.exports